import { render, staticRenderFns } from "./ProductCardMoreInfo.vue?vue&type=template&id=25f175fd&scoped=true&"
import script from "./ProductCardMoreInfo.vue?vue&type=script&lang=js&"
export * from "./ProductCardMoreInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardMoreInfo.vue?vue&type=style&index=0&id=25f175fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f175fd",
  null
  
)

export default component.exports